module.exports = __webpack_public_path__ + "static/media/back-blue.f5b25683.svg";